<template>
  <v-container id="accountEvents">
    <v-card-text v-if="loading" class="text-center py-10">
      <v-progress-circular indeterminate color="primary"/>
    </v-card-text>

    <v-alert v-else-if="error" type="error" class="text-center">
      {{ error }}
    </v-alert>

    <v-alert v-else-if="anfragen.length === 0" type="info" class="text-center">
      Sie haben noch keine Anfragen gesendet.
    </v-alert>

    <v-row v-else>
      <v-col v-for="anfrage in anfragen" :key="anfrage.id" cols="12">
        <v-card>
          <v-card-title>{{ anfrage.firmaName }}</v-card-title>
          <v-card-subtitle>
            Gesendet am {{ formatDate(anfrage.erstelltAm) }}
          </v-card-subtitle>
          <v-card-text>
            <v-list density="compact">
              <v-list-item
                  prepend-icon="mdi-list-status"
                  title="Status"
                  :subtitle="formatStatus(anfrage.status)"
              />
              <v-list-item
                  prepend-icon="mdi-shape-outline"
                  title="Kategorien"
                  :subtitle="getCategoryNames(anfrage)"
              />
              <v-list-item
                  prepend-icon="mdi-calendar-clock"
                  title="Wunschtermin"
                  :subtitle="formatDate(anfrage.wunschtermin)"
              />
              <v-list-item
                  prepend-icon="mdi-map-marker"
                  title="Auftragsadresse"
                  :subtitle="anfrage.kundenadresse?.adresse || 'Nicht angegeben'"
              />
              <v-list-item
                  prepend-icon="mdi-currency-eur"
                  title="Gesamtpreis"
                  :subtitle="formatPrice(anfrage.preis?.totalGross)"
              />
              <v-list-item
                  prepend-icon="mdi-star-outline"
                  title="Bewertung"
                  :subtitle="anfrage.bewertet ? 'Bewertung abgegeben' : 'Noch nicht bewertet'"
              />
            </v-list>
          </v-card-text>
          <v-card-actions v-if="!anfrage.bewertet">
            <v-btn color="primary" @click="openReview(anfrage)">
              <i class="fa-solid fa-star mr-2"/>
              Unternehmen bewerten
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios'
import {mapGetters} from 'vuex'

export default {
  name: 'AccountEvents',
  data() {
    return {
      anfragen: [],
      loading: false,
      error: ''
    }
  },
  computed: {
    ...mapGetters(['jwt'])
  },
  mounted() {
    this.loadRequests()
  },
  methods: {
    async loadRequests() {
      this.loading = true
      this.error = ''

      try {
        const response = await axios.get('/api/anfragen/me', {
          headers: {'x-auth-token': this.jwt}
        })

        if (!response.data?.ok) {
          this.error = response.data?.error || 'Ihre Anfragen konnten nicht geladen werden.'
          return
        }

        this.anfragen = response.data.anfragen || []
      } catch (error) {
        this.error = error.response?.data?.error || 'Ihre Anfragen konnten nicht geladen werden.'
      } finally {
        this.loading = false
      }
    },
    openReview(anfrage) {
      const slug = this.createCompanySlug(anfrage.firmaName)

      if (slug) {
        this.$emit('close-account')
        this.$nextTick(() => this.$router.push({
          path: `/${slug}`,
          query: {bewerten: anfrage.uid}
        }))
      }
    },
    createCompanySlug(value) {
      return String(value || '')
          .trim()
          .toLowerCase()
          .replace(/ä/g, 'ae')
          .replace(/ö/g, 'oe')
          .replace(/ü/g, 'ue')
          .replace(/ß/g, 'ss')
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/[^a-z0-9]/g, '')
    },
    getCategoryNames(anfrage) {
      return (anfrage.auftragsdaten?.kategorien || [])
          .map(category => category.name)
          .filter(Boolean)
          .join(', ') || 'Nicht angegeben'
    },
    formatStatus(status) {
      return {
        gesendet: 'Gesendet',
        angesehen: 'Angesehen',
        angenommen: 'Angenommen',
        abgelehnt: 'Abgelehnt',
        abgeschlossen: 'Abgeschlossen',
        storniert: 'Storniert'
      }[status] || status || 'Gesendet'
    },
    formatDate(value) {
      if (!value) return 'Nicht angegeben'

      return new Intl.DateTimeFormat('de-DE', {
        dateStyle: 'medium',
        timeStyle: 'short'
      }).format(new Date(value))
    },
    formatPrice(value) {
      return new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR'
      }).format(Number(value || 0))
    }
  }
}
</script>
